import { registerPlugin } from '@capacitor/core'

interface ActionPluginType {
  checkDeepLink(): Promise<{ value: string }>
  contentDidLoaded(): void
}
export const ActionPlugin = registerPlugin<ActionPluginType>('ActionPlugin')
